export const message = {
  MyCredits: '我的游戏积分',
  confirm: '确认',
  cancel: '取消',
  home: {
    header: '游戏积分兑换好礼',
    self_exchange: '自助兑换机',
    beer_machine: '百威生啤机',
    prize_machine: 'Cages礼品机',
    candy_machine: '自助棉花糖机',
    scan: '扫码兑换商品',
    scan_loading: '正在识别二维码',
    beer: '百威生啤',
    prize: 'Cages礼品',
    candy: '棉花糖',
    yohi_beer: '啤酒售货机',
    exchange: '使用{price}积分兑换',
    exchange_success: '兑换成功',
    exchange_beer_success: '请按照指示领取百威啤酒',
    exchange_goods_success: '请取走商品',
    count_down: '本页面将在ss秒后关闭',
    prompt: '*即日起，凡在本店消费金币玩游戏均可获得积分。积分可在礼品机和棉花糖机进行消费，请在积分到期前使用完毕',
    beer_prompt: '使用积分可以在生啤机兑换百威生啤',
    prize_prompt: '使用积分可以在礼品机兑换多种礼品，种类丰富',
    candy_prompt: '使用积分兑换棉花糖，体验自助制作棉花糖的乐趣',
    location: '位置信息待补充',
    beer_location_text: '游戏玩的大汗淋漓？按照机器上的说明，给自己来一杯冰镇的百威啤酒吧',
    prize_location_text: '从礼品机可以得到很酷的奖品——各式各样，Cages为您提供',
    beer_confirm_title: '清洗啤酒机',
    beer_confirm_message: '将一次出酒{value}ml，确认清洗吗？',
    wash_success: '清洗成功',
    wechat_prize: '请使用Cages APP兑换'
  },
  about: {
    title: '我的积分',
    tickets: '游戏积分',
    rules: '积分获取规则',
    expire_prompt: '其中{num}积分将在{date}过期，请尽快使用',
    income: '已获得',
    expenditure: '已使用',
    no_more: '没有更多了',
    game_get_tickets: '{game}，获取积分',
    rank_get_tickets: '{game}高分排行，获取积分',
    history_rank_get_tickets: '{game}历史排行，获取积分',
    month_rank_get_tickets: '{game}月排行，获取积分',
    week_rank_get_tickets: '{game}周排行，获取积分',
    default_get_tickets: '获取积分',
    cost_ticket: '兑换 {name}',
    lucky_draw: '抽奖',
    rules_detail: 'Cages现在有丰富多样的游戏，比以往更容易获得积分，您可以兑换有趣（或美味）的礼品。使用Cages app来玩游戏并收集积分。不要忘记使用您的账号，这样在结束时就可以看到谁拥有最多的积分。'
  },
  lottery_list: {
    title: '抽奖记录',
    code: '抽奖码',
    tickets: '积分',
    status: {
      ready: '未开奖',
      no_win: '未中奖',
      win: '恭喜您中奖了',
      has_change: '中奖已兑换',
    },
    detail: '抽奖详情',
    label_code: '抽奖码：{code}',
    label_status: '状态：{status}',
    winner_prompt: '恭喜您获得本次大奖“{name}"',
    contact_staff: '请联系服务员领取奖品',
    lottery_past: '将于{date}开奖，请届时查看',
    lottery_future: '已于{date}开奖',
    prize: '“{name}”',
    sn: '第{sn}期',
    to_draw: '抽奖',
    notice: '恭喜会员{encrypt_user_name}抽中第{sn}期大奖！',
    prize_previous: '上期大奖',
    prize_current: '本期大奖',
    prize_next: '下期大奖',
    date: '开奖日期{date}',
    action_previous: '已开奖',
    action_previous_waiting: '待开奖',
    action_current: '使用{cost}积分抽奖',
    action_next: '活动未开始',
    swipe_prompt: '侧滑查看上期/下期抽奖',
    rule: '抽奖规则',
    prompt: '感谢您参与本次抽奖活动，下面是您本次抽奖码，关闭页面后可在抽奖记录中查看'
  },
  lottery_rules: {
    title: '抽奖规则',
    list: [
      'Cages会员通过店内游戏可以获取积分',
      '在本页面消耗积分进行抽奖，每期仅限一次',
      '抽奖完成后，在抽奖记录页面可以查看抽奖码和中奖状态',
      '中奖后请联系店内员工使用抽奖码进行核销，领取奖品',
      '本活动最终解释权归Cages所有',
    ],
    apple: '本活动与苹果公司无关'
  },
  errors: {
    qrcode: '无效二维码',
    '1001': '积分余额不足',
    '1002': '啤酒机异常，支付失败',
    '1003': '没有找到对应订单',
    '1004': '订单状态异常，请重新支付',
    '1005': '暂无抽奖',
    '1006': '抽奖码未中奖，请核对后重新输入',
    '1007': '抽奖码已领奖，请勿重复领取',
    '1008': '抽奖每期仅限一次',
    '1010': '棉花糖机异常，支付失败',
    '1011': '棉花糖机编号错误',
    '1012': '积分价格错误，请重新支付',
    '1013': '啤酒机异常，设备查询失败',
    '1014': '啤酒机异常，订单创建失败'
  },
  date_format: 'YYYY年MM月DD日',
  coming_soon: '尚未开放，敬请期待'
}
